import { render, staticRenderFns } from "./StSocialButtonGroup.vue?vue&type=template&id=492b5f4b&"
import script from "./StSocialButtonGroup.vue?vue&type=script&lang=js&"
export * from "./StSocialButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./StSocialButtonGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports